import {ElementRef, Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {AuthService} from '../../../../auth/auth.service';
import {ServiceNotificationService} from '../../../../services/service-notification.service';
import {closeModal, mostrarToast} from '../../../../utils/utilities';
import {
  CREATE_DATA_SUCURSAL_HORARIO,
  GET_ALL_DATA_SUCURSAL_HORARIO,
  GET_DATA_SUCURSAL_HORARIO_BY_ID,
  REMOVE_DATA_SUCURSAL_HORARIO,
  UPDATE_DATA_SUCURSAL_HORARIO
} from '../../../../graphql/graphql.queris';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SucursalHorariosService {
  constructor(
    private apollo: Apollo,
    private authService: AuthService,
    private serviceNotification: ServiceNotificationService
  ) {}

  createDataSucursalHorario(input: any, addAndUpdateSucursalHorario: ElementRef) {
    try {
      const token = this.authService.getToken();
      this.apollo.mutate({
        mutation: CREATE_DATA_SUCURSAL_HORARIO,
        variables: { createDataHorarioInput: input },
        context: { headers: { Authorization: `Bearer ${token}` } }
      }).subscribe(() => {
        mostrarToast('La sucursal con su respectivo horario han sido creados correctamente', true, this.serviceNotification);
        closeModal(addAndUpdateSucursalHorario);
      });
    } catch (e) {
      console.log(e);
    }
  }

  getAllDataSucursalHorario(): Observable<any> {
    try {
      const token = this.authService.getToken();
      return this.apollo.query({
        query: GET_ALL_DATA_SUCURSAL_HORARIO,
        context: {headers: {Authorization: `Bearer ${token}`}},
        fetchPolicy: 'network-only'
      });
    } catch (e:any) {
      mostrarToast('Ha ocurrido un error inesperado', false, this.serviceNotification);
      return e;
    }
  }

  updateDataSucursalHorario(id: string, input: any, addAndUpdateSucursalHorario: ElementRef) {
    try {
      const token = this.authService.getToken();
      this.apollo.mutate({
        mutation: UPDATE_DATA_SUCURSAL_HORARIO,
        variables: { id: id, input: input },
        context: { headers: { Authorization: `Bearer ${token}` } }
      }).subscribe(() => {
        mostrarToast('La sucursal con su respectivo horario han sido actualizados correctamente', true, this.serviceNotification);
        closeModal(addAndUpdateSucursalHorario);
        this.getAllDataSucursalHorario();
      });
    } catch (e) {
      mostrarToast('Ha ocurrido un error inesperado', false, this.serviceNotification);
      console.log(e);
    }
  }

  removeDataHorario(id: string, deleteSucursalHorario: ElementRef) {
    try {
      const token = this.authService.getToken();
      this.apollo.mutate({
        mutation: REMOVE_DATA_SUCURSAL_HORARIO,
        variables: { id: id },
        context: { headers: { Authorization: `Bearer ${token}` } }
      }).subscribe(() => {
        mostrarToast('La sucursal con su respectivo horario han sido eliminados', true, this.serviceNotification);
        closeModal(deleteSucursalHorario);
      });
    } catch (e) {
      mostrarToast('Ha ocurrido un error inesperado', false, this.serviceNotification);
      console.log(e);
    }
  }

  getDataSucursalHorarioById(id: string): Observable<any> {
    try {
      const token = this.authService.getToken();
      return this.apollo.query({
        query: GET_DATA_SUCURSAL_HORARIO_BY_ID,
        variables: {id: id},
        context: {headers: {Authorization: `Bearer ${token}`}},
        fetchPolicy: 'network-only'
      });
    } catch (e:any) {
      mostrarToast('Ha ocurrido un error inesperado', false, this.serviceNotification);
      return e;
    }
  }
}
